import { makeStyles } from '@mui/styles';

export const useBaseStyles = makeStyles({
  body: {
    fill: '#fff',
    stroke: '#eee',
  },
  infoMarkersBg: {
    fill: '#ccc',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    height: '30px',
    userSelect: 'none',
    '& .icon': {
      height: '20px',
      margin: '0 5px 0 5px',
    },
    '& .text': {
      fontSize: '12px',
      fontFamily: 'sans-serif',
      fontWeight: 700,
      color: '#fff',
      overflow: 'hidden',
    },
  },
  staticParams: {
    fontSize: '11px',
    color: '#808080',
    marginBottom: '5px',
    userSelect: 'none',
  },
  staticParamsValue: {
    color: '#000',
  },
  staticParamsItem: {
    height: 12.5,
    marginBottom: '5px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    lineHeight: 'normal',
    '&:last-child': {
      marginBottom: '0',
    },
  },
  dynamicParams: {
    fontSize: '11px',
    color: '#808080',
    boxSizing: 'border-box',
    padding: '5px',
    background: '#2222220f',
    userSelect: 'none',
  },
  inactiveMarker: {
    x: 3,
    y: 4,
    width: '100%',
    height: '100%',
    fontSize: '12px',
    color: '#555',
  },
  inactiveMarkerText: {
    'float': 'left',
    marginTop: '4px',
  },
  inactiveMarkerIcon: {
    'float': 'left',
    width: 18,
    height: 18,
    borderRadius: 18,
    border: '2px solid #ffcb00',
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: '19px',
    fontWeight: 'bold',
    fontSize: 18,
    color: '#ffcb00',
    backgroundColor: '#fff',
    marginRight: '5px',
  },
  connectionPort: {
    userSelect: 'none',
    display: 'block',
    width: '20px',
    height: '20px',
    border: 'solid 1px #ccc',
    cursor: 'pointer',
    backgroundColor: '#fff',
    '&.block-node': {
      margin: '15px 0 0 72px',
    },
    '&.plug-in': {
      cursor: 'default',
      margin: '0',
    },
  },
  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  btns: {
    display: 'flex',
    width: '75px',
    justifyContent: 'flex-end',
    '& div': {
      margin: '2px 0 0 5px',
    },
  },
});

export const phaseRootProps = (props) => ({
  width: props.count * 19 - (props.count > 1 ? 1 : 0),
  height: 16,
  fontSize: '12px',
  fontWeight: 'bold',
  background: '#fff',
  padding: 1,
  overflow: 'visible',
  cursor: 'default',
  '&:hover': {
    '& .tooltip': {
      display: 'flex',
    },
  },
  '& .tooltip': {
    display: 'none',
    width: '210px',
    position: 'absolute',
    justifyContent: 'center',
    '&.edit-mode': {
      justifyContent: 'flex-start',
      left: '-20px',
    },
    '& span': {
      display: 'inline-block',
      height: '100%',
      textAlign: 'center',
      backgroundColor: 'rgba(119, 119, 119, 0.8)',
      verticalAlign: 'center',
      lineHeight: '15px',
      borderRadius: '5px',
      color: '#fff',
      fontSize: '12px',
      margin: '-55px 0 0 0',
      padding: '10px',
    },
  },
});

export const phaseItemProps = {
  'float': 'left',
  width: 16,
  height: 16,
  textAlign: 'center',
  lineHeight: '16px',
  verticalAlign: 18,
  marginRight: 1,
  userSelect: 'none',
  '&.phase-1': {
    backgroundColor: '#cde2b9',
  },
  '&.phase-2': {
    backgroundColor: '#c6e5f1',
  },
  '&.phase-3': {
    backgroundColor: '#ffe9b6',
  },
};

export const usePhaseStyles = makeStyles({
  root: phaseRootProps,
  item: phaseItemProps,
});
